import { dialogs, extensions, i18next } from '@yola/ws-sdk';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';
import constants from '../../constants/common';
import config from '../../constants/config';
import matchesOrContains from '../../helpers/matches-or-contains';

const changeImageTitle = (additionalProperties = {}) => ({
  id: constants.CHANGE_IMAGE_TITLE,
  get caption() {
    return i18next.t('Change alt title');
  },
  onClick(element) {
    const settings = extensions.accessors.getExtensionSettings(config.slug);
    const imageElement = matchesOrContains(element, settings.imageActionSelector);

    dialogs.operations.show(dialogTypes.IMAGE_ALT_DIALOG, {
      imageElement,
    });
  },
  ...additionalProperties,
});

export default changeImageTitle;
